import '../style.css';
import {
  AVAILABLE_PLATFORMS,
  type InitData,
  type models,
  type Platform
} from '../models';
import { ModalsManager } from '../modals/modals-manager';
import(/* @vite-ignore */ import.meta.env.VITE_BRAND_THEME_PATH);
import * as signalR from '@microsoft/signalr';
import * as bwcp from '@codium/bwcp/webview';
import { setCookie } from '../utils/cookie';
import { logger } from '../logger';

const app: HTMLDivElement = document.querySelector<HTMLDivElement>('#app')!;
const iframe: HTMLIFrameElement = document.createElement('iframe');

let modalsManager: ModalsManager = new ModalsManager();
let bwcpWebview: bwcp.Webview;
let initData: InitData = null;

window.addEventListener('load', () => {
  bwcp.init({}, (webview, onHandshake) => {
    bwcpWebview = webview;
    onHandshake(message => {
      initData =
        message.body.find(item => item.type === 'INIT')?.content?.parameters ||
        {};
    });
  });

  logger.log(
    'Play frame loaded. Query params: ',
    decodeURIComponent(window.location.search)
  );

  addMessagesListener();
  const queryParams = Object.fromEntries(
    new URLSearchParams(window.location.search.replace(/amp;/g, '')) ?? []
  );
  const platform: Platform = AVAILABLE_PLATFORMS.includes(
    queryParams.platform as Platform
  )
    ? (queryParams.platform as Platform)
    : 'mobile';
  let url: URL | undefined;
  try {
    url = new URL(queryParams.gameUrl);
  } catch (e) {}
  const { token, notificationToken, lobbyUrl, walletUrl } = queryParams;
  const homeUrl =
    platform === 'web'
      ? import.meta.env.VITE_HOME_URL_WEB
      : import.meta.env.VITE_HOME_URL_MOBILE;

  if (!!lobbyUrl) {
    setCookie('lobbyUrl', lobbyUrl, 1);
    console.log('LOBBY URL> ' + lobbyUrl);
  }

  if (!!walletUrl) {
    setCookie('walletUrl', walletUrl, 1);
    console.log('WALLET URL> ' + lobbyUrl);
  }

  setCookie('homeUrl', homeUrl, 1);
  setCookie('platform', platform, 1);

  if (!!url) {
    if (!!notificationToken && !!token) {
      subscribeToSignalR(encodeURIComponent(notificationToken), token);
    } else {
      logger.logError(
        'Notification token or token is not provided. SignalR not connected.'
      );
    }

    if (!!platform && !!token) {
      fetch(
        `${
          import.meta.env.DEV ? '' : import.meta.env.VITE_PLAY_FRAME_API_URL
        }/api/token/${platform}/get-game-token?platformToken=${token}`.replace(
          /\s/g,
          ''
        ),
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
        .then(response => response.json().then(({ value }) => value))
        .then(gameToken => {
          buildIframe(url, gameToken);
        })
        .catch(() => {
          logger.logError(`There was an error durring obtaining access token.`);
          buildIframe(url);
        });
    } else {
      buildIframe(url);
    }
  } else {
    setTimeout(() => {
      logger.logError(`Data for iframe not fetched.`);
      buildIframe(new URL('./lobby', window.location.href));
    }, 5000);
  }
});

function subscribeToSignalR(notificationToken: string, platformToken: string) {
  const notificationsHubEndpoint = import.meta.env.VITE_HUB_CONNECTION;
  const hub = new signalR.HubConnectionBuilder()
    .withUrl(
      notificationsHubEndpoint + '/NotificationsHub?token=' + notificationToken,
      {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      }
    )
    .withAutomaticReconnect()
    .build();

  hub.on('reward-message', (json: string) => {
    logger.log('Reward message send with JSON: ', json);
    const rewardMessage: models.RewardMessage = JSON.parse(json);

    if (rewardMessage.PlatformToken === platformToken) {
      modalsManager.openModal(rewardMessage, initData);
    }
  });

  hub.start();
}

function buildIframe(url: URL, token?: string) {
  const iframeSrc: string = url.toString().replace(/{token}/g, token ?? '');
  iframe.src = iframeSrc;
  app.append(iframe);
  logger.log('Iframe built with URL: ', iframeSrc);
}

function addMessagesListener() {
  window.addEventListener(
    'message',
    event => {
      if (
        event?.data?.type === 'redirect' ||
        event?.data?.type === 'redirect_to_url'
      ) {
        logger.log('Redirect postmessage with type: ', event?.data?.type);
        logger.log('Destination: ', event?.data?.destination);

        const queryParams = Object.fromEntries(
          new URLSearchParams(window.location.search) ?? []
        );
        const baseUrl = new URL('.', window.location.href).toString();

        const platform: Platform = queryParams['platform'] as Platform;

        let url =
          event?.data?.type === 'redirect'
            ? `doxxbet:${
                event?.data?.destination === 'lobby'
                  ? 'CasinoHome'
                  : 'DepositWithdrawal_Deposit'
              }`
            : event?.data?.destination;

        bwcpWebview.emit(
          bwcp.messages.request({
            body: [
              bwcp.actions.openLink({
                URL: url,
                FALLBACK_URL: ''
              })
            ]
          })
        );
        logger.log('BWCP message send with URL: ', url);

        setTimeout(() => {
          if (platform.toLocaleLowerCase() === 'mobile_ios') {
            if (event?.data?.type === 'redirect') {
              url =
                baseUrl +
                (event?.data?.destination === 'lobby'
                  ? '#/kasino'
                  : '#/vklady-a-vybery');
            }
            window.parent.open(url, '_self');
          } else if (platform.toLocaleLowerCase() === 'mobile_android') {
            if (event?.data?.type === 'redirect') {
              url =
                baseUrl +
                (event?.data?.destination === 'lobby'
                  ? '#/casino/home'
                  : '?cashier=1');
            }
            window.parent.open(url, '_self');
          }
          logger.log(
            "Redirect window.parent.open(url, '_self') called after timeout with URL: ",
            url
          );
        }, 100);
      }
    },
    false
  );
}
